// For full API documentation, including code examples, visit https://wix.to/94BuAAs

let fullText; // variable to hold the full text
let shortText; // variable to hold the short version of the text

$w.onReady(function () {
	// how many characters to include in the shortened version
const shortTextLength = 280;
// read the full text and store it in the fullText variable
fullText = $w("#myTextElement").text;
// grab the number of characters defined in shortTextLength and store them in the shortText variable
shortText = fullText.substr(0, shortTextLength) + "...";
// set the contents of the text element to be the short text
$w("#myTextElement").text = shortText;

});

export function myButton_click(event) {
	// check the contents of the text element 
if ($w("#myTextElement").text === shortText) {
  // if currently displaying short text, display the full text
  $w("#myTextElement").text = fullText;
  $w("#myButton").label = "Show less";    
} else {
  // if currently displaying full text, display the short text
  $w("#myTextElement").text = shortText;
  $w("#myButton").label = "Show more";
}
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function myTextElement_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}